import * as React from 'react';
import classNames from 'classnames';
import Button from 'src/components/Button';
import Icon from 'src/components/Icon';
import useOutsideClick from 'src/hooks/useOutsideClick';
import Checkbox from 'src/components/FormElements/Checkbox';
import { Column } from '../types';

type ColumnSelectProps = {
  className?: string;
  value: Column[];
  onChange: (value: Column[]) => void;
};

const columns: Array<{ value: Column, label: string }> = [
  { value: 'assigned', label: 'Tilmeldt' },
  { value: 'waitinglist', label: 'Venteliste' },
  { value: 'departmentsignup', label: 'Afdelingsansøgning' },
  { value: 'signup', label: 'Ansøgning' },
  { value: 'completed', label: 'Gennemført' }
];

const ColumnSelect = ({ className, value, onChange }: ColumnSelectProps) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  useOutsideClick(ref, () => setIsOpen(false));

  const handleChange = React.useCallback(({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const targetValue = target.value as Column;
    if (target.checked) {
      onChange(value.concat(targetValue));
    } else {
      const nextValue = value.filter((column) => column !== targetValue);
      onChange(nextValue);
    }
  }, [value]);

  return (
    <div className={classNames(className, 'relative')} ref={ref}>
      <Button color="light" onClick={() => setIsOpen(!isOpen)}>
        Vælg kolonner
        <Icon name="chevron-down" className="-mr-1 ml-2" />
      </Button>
      {isOpen && (
        <div className="absolute right-0 top-full has-background-white w-56 p-4 mt-2 shadow-xl z-20">
          <div className="-my-1">
            {columns.map((column) => (
              <div className="py-1" key={column.value}>
                <Checkbox
                  value={column.value}
                  checked={value.indexOf(column.value) > -1}
                  onChange={handleChange}
                >
                  {column.label}
                </Checkbox>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ColumnSelect;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/ColumnSelect.tsx